import { initStorageInstance } from './index'
import {
  TRAIN_NETWORK_ITEM_KEY,
} from './constant'

export const TrainNetworkItemStorage = initStorageInstance(
  TRAIN_NETWORK_ITEM_KEY,
  {
    type: 'sessionStorage',
    verifyMobile: true,
  }
)
